// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__nMKod","colored":"Button_colored__LG5h2","blackk":"Button_blackk__45rKw"};